<template>
  <div>
    <b-input-group>
      <label-info
          v-if="false"
          id="email-address"
          label-name="Email Address"
          label-info="Please enter a valid email address to receive your words"
      />
      <b-form-input
          id="email-address"
          class="custom-input"
          type="email"
          placeholder="jon@heartbeatfam.com"
          v-model="emailAddress"
      />
      <b-button
          style="margin-top: 25px;"
          variant="primary"
          :disabled="!canSend"
          @click="handleSendEmail"
          block>
        Send Email
      </b-button>
    </b-input-group>
  </div>
</template>

<script>
import LabelInfo from "@/components/common/labelInfo";
export default {
  name: "Display_Export_Email",
  components: {
    LabelInfo
  },
  created(){},
  mounted() {},
  props: {
    currIdx: {
      type: Number,
      required: false,
      default: 0
    },
    outputs:  {
      type: Array,
      required: false,
      default: ()=>{ return []}
    }
  },
  computed: {
    canSend(){
      //check validity
      return this.emailAddress && this.emailAddress.length > 0;
    }
  },
  methods: {
    handleSendEmail(){
      let email = this.createEmailObject({
        subject: 'Here are The Words for you',
        fromEmail:'DearGod@heartbeatfam.com',
        toEmail: this.emailAddress,
        emailText:this.generateBodyText()
      });

      this.$store
          .dispatch("user/sendEmail", {emails :[email]})
          .then(res => {
            const notif = {
              title:'Email Sent',
              description: `The Words email has been set to  ${this.emailAddress}`,
              variant: "success"
            };
            this.handleShowUserNotification(notif);
            this.$emit("email-sent");
          })
          .catch(rej => {
            const notif = {
              description: rej.message,
              variant: "danger"
            };
            this.handleShowUserNotification(notif);
          });
    },
    createEmailObject({subject, fromEmail, toEmail, emailText}){
      return {
        "subject": subject,
        "from": {
          "email": fromEmail
        },
        "to": [
          {
            "email": toEmail
          }
        ],
        "text": emailText
      };
    },
    generateBodyText(){
      let text="";
      if(!this.isEntireBook){
        //The Word
        let theWords = this.outputs[this.currIdx];
        if (theWords) {
          text = theWords.encouraging_words ? `THE WORDS \n${theWords.encouraging_words}` : "";
          text += theWords.scriptures ? this.generateTextScriptures(theWords.scriptures) : "";
          text += theWords.action_items ? this.generateTextActionItems(theWords.action_items) : "";
          text += theWords.parting_words ? `\n\n ${theWords.parting_words}` : "";
        }
      }
      return text;
    },
    generateTextScriptures(scriptures){
      let scriptureText = "\n\nSCRIPTURES\n";
      if(scriptures && Array.isArray(scriptures)){
       scriptures.forEach((aScripture)=>{
         scriptureText+=`${aScripture.text} - ${aScripture.book_chapter_vers ? aScripture.book_chapter_vers :'KJV' }\n`;
       })
      }
      return scriptureText;
    },
    generateTextActionItems(actionItems){
      let actionItemsText = "\n\nACTION ITEMS \n";
      if(actionItems && Array.isArray(actionItems)){
        actionItems.forEach((anActionItem)=>{
          actionItemsText+=`[] ${anActionItem}\n`;
        })
      }
      return actionItemsText;
    },
    handleShowUserNotification(message) {
      this.$store.dispatch("user/showNotification", {
        title: message.title,
        description: message.description,
        variant: message.variant
      });
    },
  },
  data() {
    return {
      status:null,
      emailAddress:null,
      isEntireBook: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
